const getters = {
  getCountries: state => state.countries
}

const actions = {
  setCountries ({ commit }, data) {
    commit('setCountries', data)
  }
}

const mutations = {
  setCountries (state, data) {
    state.countries = data
  }
}

const state = {
  countries: []
}

export default {
  namespaced: true,
  state,
  getters,
  actions,
  mutations
}
